import Task from "./Task";
import { GridItem, VStack, Text, Box } from "@chakra-ui/react";

function TaskListOther({ id, name, tasks }) {
  return (
    <GridItem key={id} borderRadius={10} border="1px" borderColor="gray.400">
      <VStack w="full" p={4}>
        <Text fontSize="2xl">{name}</Text>
        {Object.keys(tasks).length > 0 ? (
          <Text fontWeight="bold">
            {Math.round(
              (Object.values(tasks).reduce((acc, value) => {
                return acc + value["done"];
              }, 0) /
                Object.keys(tasks).length) *
                100
            )}
            % Completed
          </Text>
        ) : null}
        {tasks.length > 0 ? (
          <Box py={2} w="full">
            <VStack
              w="full"
              h="200px"
              overflowY="auto"
              border="1px"
              borderColor="gray.200"
              py={2}
              borderRadius={4}
            >
              {Object.entries(tasks).map(([key, value]) => (
                <Task
                  key={key}
                  id={key}
                  name={value.name}
                  done={value.done}
                  updateParent={null}
                  deleteTask={null}
                />
              ))}
            </VStack>
          </Box>
        ) : null}
      </VStack>
    </GridItem>
  );
}

export default TaskListOther;
